import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import authData from "../../services/authData";
import { axiosVal as axios } from "..";
const getToken = () => "LiveBearer " + localStorage.getItem('auth-token');

const initialState = {
    loaded: false,
    isLoggedin: false,
    progress: false,
    isAuthenticated: false,
    resetModalStatus: false,
    dayOffstatus: false,
    timeoffs: [],
    userHistory: [],
    remainDays: {},
    updateDate: {},
    pendingRequets: [],
    history: [],
    error: {
        status: false,
        message: ""
    },
    success: {
        status: false,
        message: ""
    }
};

export const getAllTimeOff = createAsyncThunk('timeoff/getall', async() => {
    
    const response = await axios.get(
        `/timeoff`,
        {
            headers: {
                'x-auth': getToken(),
            },
        }
    );

    return response?.data;
});

export const getPendingTimeOff = createAsyncThunk('timeoff/pending', async() => {
    
    const response = await axios.get(
        `/timeoff/pending`,
        {
            headers: {
                'x-auth': getToken(),
            },
        }
    );

    return response?.data;
});


export const getRequestHistory = createAsyncThunk('timeoff/requestsHistory', async() => {
    
    const response = await axios.get(
        `timeoff/me/history`,
        {
            headers: {
                'x-auth': getToken(),
            },
        }
    );

    return response?.data;
});

export const getUserHistory = createAsyncThunk('timeoff/userRequestsHistory', async(id) => {
    
    const response = await axios.get(
        `timeoff/${id}/history`,
        {
            headers: {
                'x-auth': getToken(),
            },
        }
    );

    return response?.data;
});

export const getUserDays = createAsyncThunk('timeoff/userRequestsDays', async(id) => {
    
    const response = await axios.get(
        `timeoff/${id}/days`,
        {
            headers: {
                'x-auth': getToken(),
            },
        }
    );

    return response?.data;
});

export const timeOffRequest = createAsyncThunk('timneoff/request', async (userData) => {

    try {
        const response = await axios.post('/timeoff', userData, {
            headers: {
                'x-auth': getToken(),
                'Content-Type': 'multipart/form-data'
            },
        });
    
        return response?.data;
    }
    catch(error) {
        throw error.response.data;
    }
});

export const rejectRequest = createAsyncThunk('timeoff/requestReject', async (requestData) => {
    const response = await axios.delete(`/timeoff/${requestData}`,  {
        headers: {
            'x-auth': getToken(),
        },
    });

    return response?.data;
});

export const approveReuquest = createAsyncThunk('timeoff/requestApprove', async (requestData) => {
    const response = await axios.post(`/timeoff/${requestData}/approve`, {}, {
        headers: {
            'x-auth': getToken(),
        },
    });

    return response?.data;
})

export const UpdateDayoffValue = createAsyncThunk('timeoff/manager/changedayof', async ({id, dayoff}) => {
    const response = await axios.put(`/timeoff/${id}/manager/changedayoff`, {dayoff}, {
        headers: {
            'x-auth': getToken(),
        },
    });

    return response?.data;
})

export const cancelRequest = createAsyncThunk('timeoff/cancel', async (requestId) => {
    const response = await axios.delete(`/timeoff/${requestId}/cancel`, {
        headers: {
            'x-auth': getToken(),
        },
    });

    return response?.data;
})

const timeoffSlice = createSlice({
    name: "timeoff",
    initialState,
    reducers: {
        reset: (state) => {
            return initialState;
        },
        updateDayOffModalStatus(state, action) {
            state.dayOffstatus = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getAllTimeOff.fulfilled, (state, action) => {
            state.timeoffs = action.payload;
        })
        builder.addCase(timeOffRequest.fulfilled, (state, action) => {
            state.success.status = true;
            state.error.status = false;
        })
        builder.addCase(timeOffRequest.pending, (state, action) => {
            state.success.status = false;
            state.error.status = false;
        })
        builder.addCase(timeOffRequest.rejected, (state, action) => {
            state.error.status = true;
            state.success.status = false;
            state.error.message = action.error.message;
        })
        builder.addCase(getPendingTimeOff.fulfilled, (state, action) => {
            state.pendingRequets = action.payload;
        })
        builder.addCase(getRequestHistory.fulfilled, (state, action) => {
            state.history = action.payload;
        })
        builder.addCase(rejectRequest.fulfilled, (state, action) => {
            state.pendingRequets = action.payload;
        })
        builder.addCase(approveReuquest.fulfilled, (state, action) => {
            state.pendingRequets = action.payload;
        })
        builder.addCase(getUserHistory.pending, (state, action) => {
            state.userHistory = [];
        })
        builder.addCase(getUserHistory.fulfilled, (state, action) => {
            state.userHistory = action.payload;
            state.updateDate = new Date().toISOString()
        })
        builder.addCase(getUserDays.pending, (state, action) => {
            state.remainDays = {};
        })
        builder.addCase(getUserDays.fulfilled, (state, action) => {
            state.remainDays = action.payload;
        })
        builder.addCase(UpdateDayoffValue.fulfilled, (state, action) => {
            state.remainDays.dayoff = action.payload;
            state.dayOffstatus = false;
        })
        builder.addCase(cancelRequest.fulfilled, (state, action) => {
            state.userHistory = action.payload.history;
            state.updateDate = new Date().toISOString();
            state.remainDays = action.payload.days;
        })
    }
});

export const timeoffActions = timeoffSlice.actions;
export const timeoffReducer = timeoffSlice.reducer;